"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithClassName = void 0;
class WithClassName {
    constructor() {
        // @ts-ignore
        this.className = this.constructor['name'];
    }
}
exports.WithClassName = WithClassName;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/with-class-name.js
// module id = 1217
// module chunks = 0